// ===== DEBOUNCE UTILITY =====
function debounce(fn, delay) {
    var timer;
    return function () {
        clearTimeout(timer);
        var context = this, args = arguments;
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
}

$(document).ready(function () {

    // ================= CUSTOMER REVIEWS SLIDER =================
    if ($('.reviews-wrapper').length) {
        $('.reviews-wrapper').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            adaptiveHeight: true,
            prevArrow: `
                <button type="button" class="slick-prev custom-arrow custom-prev" aria-label="Previous">
                <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.7823 4.0762L14.9036 0.216123C14.613 -0.0729965 14.1431 -0.0719206 13.8539 0.218646C13.5648 0.509175 13.5659 0.979091 13.8564 1.26825L16.4602 3.85937H0.742188C0.332277 3.85937 0 4.19165 0 4.60156C0 5.01147 0.332277 5.34375 0.742188 5.34375H16.4601L13.8565 7.93487C13.5659 8.22403 13.5648 8.69395 13.854 8.98448C14.1432 9.27508 14.6131 9.27608 14.9036 8.987L18.7817 5.12762C19.0724 4.8375 19.0721 4.36536 18.7823 4.0762Z" fill="#636363"/>
                </svg>
                </button>`,
            nextArrow: `
                <button type="button" class="slick-next custom-arrow custom-next" aria-label="Next">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.7823 9.0762L14.9036 5.21612C14.613 4.927 14.1431 4.92808 13.8539 5.21865C13.5648 5.50918 13.5659 5.97909 13.8564 6.26825L16.4602 8.85937H0.742188C0.332277 8.85937 0 9.19165 0 9.60156C0 10.0115 0.332277 10.3437 0.742188 10.3437H16.4601L13.8565 12.9349C13.5659 13.224 13.5648 13.6939 13.854 13.9845C14.1432 14.2751 14.6131 14.2761 14.9036 13.987L18.7817 10.1276C19.0724 9.8375 19.0721 9.36536 18.7823 9.0762Z" fill="#636363"/>
                </svg>
                </button>`,
            responsive: [
                { breakpoint: 1200, settings: { slidesToShow: 3 } },
                { breakpoint: 992, settings: { slidesToShow: 2 } },
                { breakpoint: 576, settings: { slidesToShow: 1, arrows: false, dots: true } }
            ]
        });
    }

    // ================= READ MORE / READ LESS =================
    if ($('.review-text').length) {
        $('.review-text').each(function () {
            var fullText = $(this).text().trim();
            var words = fullText.split(/\s+/);
            var maxWords = 14;

            if (words.length > maxWords) {
                var shortText = words.slice(0, maxWords).join(' ');
                $(this).html(shortText + '... <span class="read-more-inline">Read more</span>');
                $(this).attr('data-full', fullText);
                $(this).attr('data-short', shortText);
            }
        });
    }

    $(document).on('click', '.read-more-inline', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var parent = $(this).closest('.review-text');
        var card = $(this).closest('.review-card');
        var fullText = parent.attr('data-full');
        var shortText = parent.attr('data-short');

        if ($(this).text().includes('Read more')) {
            parent.html(fullText + ' <span class="read-more-inline">Read less</span>');
        } else {
            parent.html(shortText + '... <span class="read-more-inline">Read more</span>');
        }

        parent.css('height', 'auto');
        if (card.length) card.css('height', 'auto');

        var reviewsWrapper = $('.reviews-wrapper');
        if (reviewsWrapper.length && reviewsWrapper.hasClass('slick-initialized')) {
            reviewsWrapper.slick('setPosition');
        }
    });

    // ================= KEY HIGHLIGHTS SLIDER =================
    if ($('.slick-key-highlights').length) {
        $('.slick-key-highlights').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            centerMode: false,
            arrows: true,
            dots: false,
            autoplay: false,
            speed: 600,
            prevArrow: `
            <button type="button" class="slick-prev custom-arrow">
                <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path>
                </svg>
            </button>`,
            nextArrow: `
            <button type="button" class="slick-next custom-arrow">
                <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path>
                </svg>
            </button>`,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } }
            ]
        });
    }

    // ================= INLINE VIDEO AUTOPLAY (Lazy - Intersection Observer) =================
    // OPTIMIZED: Instead of playing all videos on load, now plays only when visible in viewport
    if ('IntersectionObserver' in window) {
        var videoObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                var video = entry.target;
                if (entry.isIntersecting) {
                    video.play().catch(function () {});
                } else {
                    video.pause();
                }
            });
        }, { threshold: 0.3 });

        document.querySelectorAll('.kh-inline-video').forEach(function (video) {
            videoObserver.observe(video);
        });
    } else {
        // Fallback for older browsers
        if ($('.kh-inline-video:visible').length) {
            $('.kh-inline-video:visible').each(function () {
                this.play().catch(function () {});
            });
        }
    }

    // ================= KEY HIGHLIGHTS POPUP =================
    // OPTIMIZED: Delegated to .kh-section container instead of document
    var $khSection = $('.kh-section');
    var $khDelegate = $khSection.length ? $khSection : $(document);

    $khDelegate.on('click', '.kh-item', function (e) {
        e.preventDefault();
        var type = $(this).data('type');
        var src = $(this).data('src');
        var popupContent = $('.kh-popup-content');

        if (!popupContent.length) return;

        popupContent.html('');
        if (type === 'image') {
            popupContent.html('<img src="' + src + '">');
        } else {
            popupContent.html(`
                <video id="khPopupVideo" muted playsinline loop>
                    <source src="${src}">
                </video>
            `);
            setTimeout(function () {
                var v = document.getElementById('khPopupVideo');
                if (v) v.play().catch(function () {});
            }, 100);
        }

        var popup = $('.kh-popup');
        if (popup.length) {
            popup.fadeIn();
            $('body').addClass('kh-popup-open');
        }
    });

    $khDelegate.on('click', '.kh-popup, .kh-close', function () {
        var v = document.getElementById('khPopupVideo');
        if (v) {
            v.pause();
            v.currentTime = 0;
        }
        var popup = $('.kh-popup');
        if (popup.length) {
            popup.fadeOut();
            $('.kh-popup-content').html('');
            $('body').removeClass('kh-popup-open');
        }
    });

    // ================= CUSTOM SIZE POPUP (PRODUCT PAGE ONLY) =================
    if (!$('body').hasClass('template-product')) return;

    var currentStep = 0;
    var measurements = {};
    var isEditing = false;
    var activePopup = null;

    // OPTIMIZED: Cache popup references once
    var $lehengaPopup = $('#virtualTailorPopup');
    var $sareePopup = $('#virtualsareePopup');

    // OPTIMIZED: Combined popup container for specific event delegation
    var $allPopups = $lehengaPopup.add($sareePopup);

    function getTotalSteps() {
        if (!activePopup || !activePopup.length) return 0;
        return activePopup.find('.vt-step').length - 1;
    }

    function updateProgress(step) {
        if (!activePopup || !activePopup.length) return;
        var totalSteps = getTotalSteps();
        var bar = activePopup.find('.vt-progress-bar');
        if (!bar.length) return;

        if (step === 0) {
            bar.css('width', '2%').text('0%');
            return;
        }
        var percent = Math.round((step / totalSteps) * 100);
        bar.css('width', percent + '%').text(percent + '%');
    }

    function showStep(step) {
        if (!activePopup || !activePopup.length) return;
        var totalSteps = getTotalSteps();

        activePopup.find('.vt-step').removeClass('active');
        var stepDiv = activePopup.find('.vt-step[data-step="' + step + '"]');
        if (!stepDiv.length) return;
        stepDiv.addClass('active');
        updateProgress(step);

        var prevBtn = activePopup.find('.vt-prev');
        var nextBtn = activePopup.find('#vtNextBtn');

        if (step === 0) {
            if (prevBtn.length) prevBtn.hide();
            if (nextBtn.length) nextBtn.show().text('NEXT');
        } else if (step === totalSteps - 1) {
            if (prevBtn.length) prevBtn.show();
            if (nextBtn.length) nextBtn.show().text(isEditing ? 'NEXT' : 'REVIEW');
        } else if (step === totalSteps) {
            if (prevBtn.length) prevBtn.hide();
            if (nextBtn.length) nextBtn.hide();
        } else {
            if (prevBtn.length) prevBtn.show();
            if (nextBtn.length) nextBtn.show().text('NEXT');
        }

        var input = stepDiv.find('.measure-input, textarea');
        if (input.length) {
            var key = input.data('key');
            if (key && measurements[key]) {
                input.val(measurements[key]);
            }
        }

        playStepVideo(step);
    }

    function buildReview() {
        if (!activePopup || !activePopup.length) return;
        var reviewList = activePopup.find('#reviewList');
        if (!reviewList.length) return;

        var html = '<ol class="vt-review-list">';
        activePopup.find('.measure-input, textarea').each(function () {
            var key = $(this).data('key');
            var label = $(this).data('label');
            if (!key || !label) return;
            var value = measurements[key] || '';
            html += `
            <li>
                <span class="vt-label">${label}</span>
                <div class="vt-right">
                    <span class="vt-value">${value}</span>
                    <a href="#" class="edit-measure" data-key="${key}">Edit</a>
                </div>
            </li>`;
        });
        html += '</ol>';
        reviewList.html(html);
    }

    function playStepVideo(stepIndex) {
        if (!activePopup || !activePopup.length) return;
        var step = activePopup.find('.vt-step[data-step="' + stepIndex + '"]');
        if (!step.length) return;
        var video = step.find('video').get(0);
        if (!video) return;
        video.pause();
        video.currentTime = 0;
        video.muted = true;
        video.play().catch(function () {});
    }

    // Open Custom Size Popup
    $(document).on('click', '.product-form__input label, .swatch-element.customsize .single-label', function (e) {
        var collectionName = $(this).data('collection-name');
        var text = $(this).find('.text').text().trim().toLowerCase();

        if (text !== 'custom size') return;
        if (!collectionName) return;

        collectionName = collectionName.toLowerCase();
        e.preventDefault();
        e.stopPropagation();

        currentStep = 0;
        measurements = {};
        isEditing = false;

        if (collectionName === 'lehenga') {
            activePopup = $lehengaPopup;
        } else if (collectionName === 'saree' || collectionName === 'salwar') {
            activePopup = $sareePopup;
        } else {
            return;
        }

        if (!activePopup.length) return;
        activePopup.fadeIn(200);
        showStep(0);
    });

    // OPTIMIZED: All popup events delegated to $allPopups instead of document
    // Next Button
    $allPopups.on('click', '.vt-next', function () {
        if (!activePopup || !activePopup.length) return;
        var totalSteps = getTotalSteps();
        var stepDiv = activePopup.find('.vt-step.active');
        if (!stepDiv.length) return;

        var input = stepDiv.find('.measure-input, textarea');
        var errorBox = stepDiv.find('.vt-error');

        if (input.length) {
            var val = input.val();
            var min = parseFloat(input.attr('min'));
            var max = parseFloat(input.attr('max'));
            if (input.attr('type') === 'number') {
                val = parseFloat(val);
                if (isNaN(val) || val < min || val > max) {
                    if (errorBox.length) errorBox.show();
                    return false;
                }
                if (errorBox.length) errorBox.hide();
            }
            measurements[input.data('key')] = input.val();
        }

        if (isEditing) {
            isEditing = false;
            currentStep = totalSteps;
            showStep(currentStep);
            buildReview();
            return;
        }

        if (currentStep < totalSteps) {
            currentStep++;
            showStep(currentStep);
        }
        if (currentStep === totalSteps) {
            buildReview();
        }
    });

    // Prev Button
    $allPopups.on('click', '.vt-prev', function () {
        if (!activePopup || !activePopup.length) return;
        if (currentStep > 0) {
            currentStep--;
            showStep(currentStep);
        }
    });

    // Edit Measurement
    $allPopups.on('click', '.edit-measure', function (e) {
        e.preventDefault();
        if (!activePopup || !activePopup.length) return;
        isEditing = true;
        var key = $(this).data('key');
        activePopup.find('.measure-input, textarea').each(function () {
            if ($(this).data('key') === key) {
                currentStep = $(this).closest('.vt-step').data('step');
                showStep(currentStep);
            }
        });
    });

    // Close Popup
    $allPopups.on('click', '.vt-close', function () {
        if (!activePopup || !activePopup.length) return;
        activePopup.fadeOut();
    });

    // Final Submit
    $allPopups.on('click', '#finalSubmitBtn', function () {
        if (!activePopup || !activePopup.length) return;

        var fieldMap = {
            '#prop_front_neck': 'front_neck',
            '#prop_back_neck': 'back_neck',
            '#prop_bust': 'bust',
            '#prop_under_bust': 'under_bust',
            '#prop_shoulder_back': 'shoulder_back',
            '#prop_armhole': 'armhole',
            '#prop_biceps': 'biceps',
            '#prop_sleeve': 'sleeve',
            '#prop_blouse': 'blouse',
            '#prop_waist': 'waist',
            '#prop_hips': 'hips',
            '#prop_lehenga': 'lehenga',
            '#prop_designer_note': 'designer_note'
        };

        $.each(fieldMap, function (selector, key) {
            var el = $(selector);
            if (el.length) el.val(measurements[key] || '');
        });

        activePopup.fadeOut();
    });

    // Enter Key to go Next
    $allPopups.on('keypress', '.measure-input', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            if (activePopup && activePopup.length) {
                activePopup.find('.vt-next').trigger('click');
            }
        }
    });

});


  document.addEventListener("DOMContentLoaded", function () {
        function filterImagesByColor(filterClass) {
            const isMobile = window.innerWidth <= 768;
            const images = document.querySelectorAll(".productView-image");

            /* ================= DESKTOP ================= */
            if (!isMobile) {
                images.forEach(function (img) {
                    img.classList.add("is-hidden");
                });

                let activeImages = document.querySelectorAll(filterClass);

                if (activeImages.length === 0) {
                    const color = filterClass.replace(".filter-", "");
                    activeImages = document.querySelectorAll('[data-color="' + color + '"]');
                }

                if (activeImages.length === 0) {
                    images.forEach((img) => img.classList.remove("is-hidden"));
                } else {
                    activeImages.forEach((img) => img.classList.remove("is-hidden"));
                }

            } else {

                /* ================= MOBILE ================= */
                if (typeof jQuery !== "undefined") {
                    var $slider = jQuery(".productView-nav");

                    if ($slider.hasClass("slick-initialized")) {
                        let $target = $slider.find(filterClass).first();

                        if ($target.length === 0) {
                            const color = filterClass.replace(".filter-", "");
                            $target = $slider.find('[data-color="' + color + '"]').first();
                        }

                        if ($target.length > 0) {
                            let index = $target.data("slick-index");

                            if (index === undefined) {
                                index = $target.index();
                            }

                            $slider.slick("slickSetOption", "speed", 0, true);
                            $slider.slick("slickGoTo", index, false);

                            setTimeout(function () {
                                $slider.slick("slickSetOption", "speed", 300, true);
                            }, 50);
                        }
                    }
                }
            }
        }

        /* color change event */
        const radios = document.querySelectorAll('input[name="Color"]');

        radios.forEach(function (radio) {
            radio.addEventListener("change", function () {
                const filterClass = this.getAttribute("data-filter");
                filterImagesByColor(filterClass);

                // store last selected color
                window.selectedFilterClass = filterClass;
            });
        });

        /* run on page load */
        window.addEventListener("load", function () {
            const activeRadio = document.querySelector('input[name="Color"]:checked');
            if (activeRadio) {
                const filterClass = activeRadio.getAttribute("data-filter");
                filterImagesByColor(filterClass);
                window.selectedFilterClass = filterClass;
            }
        });

        /* run again on resize */
        window.addEventListener("resize", function () {
            if (window.selectedFilterClass) {
                filterImagesByColor(window.selectedFilterClass);
            }
        });

    /* default load */
    const defaultColor = document.querySelector('input[name="Color"]:checked');
    if (defaultColor) {
        const filterClass = defaultColor.getAttribute("data-filter");
        filterImagesByColor(filterClass);
    }

    function initMobileSlider() {
        var $slider = jQuery(".productView-nav");
        if (window.innerWidth <= 768) {
            if (!$slider.hasClass("slick-initialized")) {
                $slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    infinite: false,
                    swipeToSlide: true,
                    touchThreshold: 10,
                    adaptiveHeight: false,
                    cssEase: "ease-in-out",
                    prevArrow: `
                            <button type="button" class="slick-prev custom-arrow">
                                <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path>
                                </svg>
                            </button>
                            `,
                    nextArrow: `
                            <button type="button" class="slick-next custom-arrow">
                                <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path>
                                </svg>
                            </button>
                            `,
                    mobileFirst: true,
                });
            }
        } else {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("unslick");
            }
        }
    }
        initMobileSlider();
        jQuery(window).on("resize", function () {
            initMobileSlider();
        });
    });